import { useState } from 'react'
import { Avatar } from '@/presentation/components/ui/avatar'

interface DriverAvatarProps {
  photo?: string | null
  name?: string | null
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const getInitials = (name?: string | null): string => {
  if (!name) return '?'
  const nameParts = name.split(' ').filter(Boolean).slice(0, 2)
  return nameParts
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

const sizeClasses = {
  sm: 'h-8 w-8 text-sm',
  md: 'h-10 w-10 text-base', 
  lg: 'h-16 w-16 text-xl sm:h-20 sm:w-20 sm:text-2xl'
}

export function DriverAvatar({ photo, name, className = '', size = 'md' }: DriverAvatarProps) {
  const [photoLoaded, setPhotoLoaded] = useState(false)
  const [photoError, setPhotoError] = useState(false)

  const handlePhotoLoad = () => {
    setPhotoLoaded(true)
    setPhotoError(false)
  }

  const handlePhotoError = () => {
    setPhotoLoaded(false)
    setPhotoError(true)
  }

  const showInitials = !photo || photoError || !photoLoaded

  return (
    <Avatar className={`${sizeClasses[size]} flex-shrink-0 relative flex items-center justify-center bg-muted font-medium ${className}`}>
      {photo && (
        <img
          src={photo}
          alt={name ?? 'Driver'}
          className="w-full h-full object-cover rounded-full"
          onLoad={handlePhotoLoad}
          onError={handlePhotoError}
        />
      )}
      {showInitials && (
        <span className="absolute inset-0 flex items-center justify-center">
          {getInitials(name)}
        </span>
      )}
    </Avatar>
  )
}